export default class SMSVerification {
  number!: string;
}
